export class SuburbSearch {
  cityId: string;
}